import onUserHasConsentedToCookies from "../../../../CodeQ.Site/Resources/Private/Fusion/onUserHasConsentedToCookies";

if(document.querySelector('.aggregator-load-after-consent')) {
    onUserHasConsentedToCookies('preference', () => {
        Array.from(document.querySelectorAll('.aggregator-load-after-consent')).forEach(el => {
            el.setAttribute('src', el.getAttribute('data-src'));
            el.classList.remove('aggregator-load-after-consent');
        })
    }, true);;
}
